<template>
  <div>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="selectInfo" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="selectInfo.wareId" placeholder="仓房选择">
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择时间">
          <el-date-picker
            v-model="selectInfo.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getselectInfo">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <el-button type="primary" class="commonBtn totalExcel" plain @click="totalExcel">导出<i class="el-icon-document el-icon--right"></i></el-button>
          <el-switch
            v-if='type=="water"'
            style='margin-left:15px'
            @change='switchChange'
            v-model="gatherSwitch"
            active-text="显示湿度"
            inactive-text="显示水分"
            class='gatherSwitch'>
          </el-switch>
          <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
            <el-table
              :data="tableData"
              ref="report-table"
              style="width: 100%"
              v-if="tableData.length>0"
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              :max-height="height-125"
              id='exportTableExcel'
            > 
              <el-table-column
                prop="wareName"
                label="仓房名称"
                align="center"
                fixed
                width="80">
              </el-table-column>
              <el-table-column
                prop="wareType"
                label="仓房类型"
                align="center"
                width="80">
              </el-table-column>
              <el-table-column
                prop="foodFariety"
                label="粮食品种"
                align="center"
                width="80">
              </el-table-column>
              <el-table-column
                prop="storageReal"
                label="实际储量"
                align="center"
                width="120">
              </el-table-column>
              <el-table-column
                v-if='gatherType=="hum"'
                prop="humMax"
                label="最高湿度"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-else-if='gatherType=="water"'
                prop="waterMax"
                label="最高水分"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-else
                prop="tempMax"
                label="最高粮温"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-if='gatherType=="hum"'
                prop="humMin"
                label="最低湿度"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-else-if='gatherType=="water"'
                prop="waterMin"
                label="最低水分"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-else
                prop="tempMin"
                label="最低粮温"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-if='gatherType=="hum"'
                prop="humAve"
                label="平均湿度"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-else-if='gatherType=="water"'
                prop="waterAve"
                label="平均水分"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                v-else
                prop="tempAve"
                label="平均粮温"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                prop="tempIn"
                label="仓内温"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                prop="tempOut"
                label="仓外温"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                prop="humidityIn"
                label="仓内湿"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                prop="humidityOut"
                label="仓外湿"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                :label="'第'+item+'层'"
                v-for="(item,index) in maxLayer"
                :key="index"
                align="center">
                <el-table-column label="最高湿度" width="70" align="center" v-if='gatherType=="hum"'>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].infoHumMax:''}}
                  </template>
                </el-table-column>
                 <el-table-column label="最高水分" width="70" align="center" v-else-if='gatherType=="water"'>
                  <template slot-scope="scope" >
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].infoWaterMax:''}}
                  </template>
                </el-table-column>
                 <el-table-column label="最高温" width="70" align="center" v-else>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].tempMax:''}}
                  </template>
                </el-table-column>
                <el-table-column label="最低湿度" width="70" align="center" v-if='gatherType=="hum"'>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].infoHumMin:''}}
                  </template>
                </el-table-column>
                <el-table-column label="最低水分" width="70" align="center" v-else-if='gatherType=="water"'>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].infoWaterMin:''}}
                  </template>
                </el-table-column>
                <el-table-column label="最低温" width="70" align="center" v-else>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].tempMin:''}}
                  </template>
                </el-table-column>
                <el-table-column label="平均湿度" width="70" align="center" v-if='gatherType=="hum"'>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].infoHumAve:''}}
                  </template>
                </el-table-column>
                <el-table-column label="平均水分" width="70" align="center" v-else-if='gatherType=="water"'>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].infoWaterAve:''}}
                  </template>
                </el-table-column>
                <el-table-column label="平均温" width="70" align="center" v-else>
                  <template slot-scope="scope">
                    {{tableData[scope.$index].infoList[index]?tableData[scope.$index].infoList[index].tempAve:''}}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="采集时间"
                align="center"
                width="150">
              </el-table-column>
              <el-table-column
                prop="custodian"
                label="保管员"
                align="center"
                width="70">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
import exportTableExcel from '../../exportTableExcel.js'
export default {
  props:{
    width:Number,
    height:Number,
    type:String
  },
  data(){
    return{
      selectInfo:{
        wareId:'all',
        date:'',
      },
      wareList:[],
      tableData:[],
      wareIds:[],
      maxLayer:0,
      gatherSwitch:false,
      gatherType:''
    }
  },
  created(){
    this.getWareList()
  },
  methods:{
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          let arr=[{wareId:'all', wareName: "全部"}]
          this.wareList=[...arr,...res.data]
          let allWareId=[]
          res.data.forEach(item=>{
            allWareId.push(item.wareId)
          })
          this.wareIds=allWareId
        }
      })
    },
    getselectInfo(){
      this.getTotalInfo()
    },
    getTotalInfo(){
      if(this.selectInfo.date==''){
        this.$message({
          type: 'info',
          message: "请选择时间",
          duration:1000
        });
        return 
      }
      let params={
        date:this.selectInfo.date
      }
      if(this.selectInfo.wareId=='all'){
        params.wareIds=this.wareIds
      }else{
        params.wareIds=[this.selectInfo.wareId]
      }
      let gatherType=''
      if(this.type=='water'){
        params.hasWater=1;
        if(this.gatherSwitch){
          gatherType='hum'
        }else{
          gatherType='water'
        }
      }
      this.gatherType=gatherType;
      axios.get('/system/grain/summary',{
        params:params,
        paramsSerializer:{
          serialize:params => {
            return this.$qs.stringify(params, { arrayFormat: "repeat" })
          }
        } 
      }).then(res=>{
        if(res.code==200){
          let max=0;
          for(let i=0;i<res.data.length;i++){
            if(max<res.data[i].infoList.length){
              max=res.data[i].infoList.length
            }
          }
          this.maxLayer=max;
          this.tableData=res.data
        }
      })
    },
    totalExcel(){
      if(this.tableData.length>0){
        const $e = this.$refs['report-table'].$el;
        let name='';
        if(this.gatherType=='hum'){
          name='湿度数据汇总'
        }else if(this.gatherType=='water'){
          name='水分数据汇总'
        }else{
          name='粮温数据汇总'
        }
        exportTableExcel.exportExcel($e,name,'.xlsx',true)
      }
    },
    switchChange(val){
      if(val){
        this.gatherType="hum"
      }else{
        this.gatherType='water'
      }
    }
  }
}
</script>

<style>
  #exportTableExcel .el-table__body-wrapper::-webkit-scrollbar{
    width: 10px !important;
    height: 10px !important;
  }
  .totalExcel{
    left: 15px
  }
  .gatherSwitch{
    position: absolute;
    top:20px;
    left: 150px;
  }
</style>
